import { ComponentType } from "react"
import PromotionPopup000 from "./promotions/PromotionPopup000"
import PromotionPopup418 from "./promotions/PromotionPopup418"

export interface PromotionEventPopupComponentProps {
  onClose: () => void
}

export type PromotionEnv = "L" | "D" | "S" | "P"

/** 이벤트 완료 조건에 사용되는 액션 타입 */
export type EventActionType = "book" | "sentence"

export type PromotionEventComponentPopupConfig = {
  type: "component"
  component: ComponentType<PromotionEventPopupComponentProps>
  defaultExpireDate?: string // 기본 만료 날짜 (yyyy-mm-dd 형식)
  actions: EventActionType[] // 이벤트 완료에 필요한 액션 목록
  actionsMode?: "and" | "or" // "and": 모든 액션 완료 필요 (기본값), "or": 하나만 완료해도 됨
  headerEventCodeByEnv?: Partial<Record<PromotionEnv, string>>
}

export type PromotionEventPopupConfig = PromotionEventComponentPopupConfig

export type PromotionEventPopupDefinitions = Record<
  string,
  PromotionEventPopupConfig
>

/**
 * 프로모션 이벤트 팝업 정의
 *
 * 새 이벤트 추가 시:
 * 1. 팝업 컴포넌트 등록
 * 2. actions: 완료 조건 액션 배열 (예: ["book"], ["book", "sentence"])
 * 3. actionsMode: "and" (모두 완료) | "or" (하나만 완료) - 기본값 "and"
 *
 * 사용처: checkEvent("book") - 해당 액션을 가진 모든 활성 이벤트 자동 처리
 */
export const PROMOTION_EVENT_POPUP_CONFIG: PromotionEventPopupDefinitions = {
  "000": {
    type: "component",
    component: PromotionPopup000,
    defaultExpireDate: "2025-12-14",
    actions: ["book"],
    actionsMode: "or", // 하나만 완료해도 팝업
  },
  "418": {
    type: "component",
    component: PromotionPopup418,
    defaultExpireDate: "2026-02-28",
    actions: ["book", "sentence"],
    actionsMode: "and", // 둘 다 완료해야 팝업
    headerEventCodeByEnv: {
      D: "418",
      S: "918",
    },
  },
}
